import { SupportDetailsCtrl } from './support-details.controller';

export const SupportDetailsComponent = {
  template: require('./support-details.html'),
  bindings: {
    support: '<',
    studentSupports: '<',
    attendanceRecords: '<',
  },
  controller: SupportDetailsCtrl,
};
